export const addPaddingZerosToNum = (number, numberOfZeros, resultLength) => {
  // const arrayOfZeros = Array(numberOfZeros).fill('0');
  // const numberConvertedToArr = number.toString().split('');
  // const concatinatedArr = arrayOfZeros.concat(numberConvertedToArr);
  // const resultArr = concatinatedArr.slice(
  //   concatinatedArr.length - resultLength,
  //   concatinatedArr.length,
  // );
  // return resultArr.join('');

  const zerosStr = Array(numberOfZeros).fill('0').join();
  const concatinatedStr = zerosStr + number;
  const resultStr = concatinatedStr.slice(-resultLength);
  return resultStr;
};
